import { render, staticRenderFns } from "./PostEditImmoOfferV.vue?vue&type=template&id=2478281c&"
import script from "./PostEditImmoOfferV.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoOfferV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports